document.addEventListener("DOMContentLoaded", function () {

    var skip = 0;
    var maxitems = 10;
    var id = null;
    var loader = null;
    var currentItem = 0;
    var right = false;
    var detailsLink;

    document.querySelectorAll(".newsloader").forEach(function (el) {
        loader = el;
        skip = 0;
        maxitems = parseInt(el.dataset.maxitems, 10) || 10;
        detailsLink = el.dataset.detailslink;
        console.log("Details link: ", detailsLink);
        id = el.dataset.newsroot;
        loadArticles();
        var loadBtn = el.querySelector("button.load");
        if (loadBtn) {
            loadBtn.addEventListener("click", function () {
                loadArticles();
            });
        }
    });

    function loadArticles(callback) {
        var url = "/umbraco/surface/NewsSurface/LoadMore/" + id + "?skip=" + skip + "&take=" + maxitems;
        fetch(url, { cache: "no-store" })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                if (data.Urls) {
                    data.Urls.forEach(function (urlPath) {
                        var cleanUrl = urlPath + (right ? "?right=true" : "");
                        var ctr = document.createElement("div");
                        var nlContent = loader.querySelector(".nl-content");
                        if (nlContent) {
                            nlContent.appendChild(ctr);
                        }
                        fetch(cleanUrl)
                            .then(function (res) {
                                return res.text();
                            })
                            .then(function (html) {
                                ctr.innerHTML = html;
                                currentItem++;
                                if (currentItem % 2 === 1) {
                                    ctr.querySelectorAll(".newsitem .col-12").forEach(function (col) {
                                        col.classList.add("column");
                                    });
                                }
                            });
                        right = !right;
                    });
                }
                skip += maxitems;
                if (skip >= data.totalItems) {
                    var loadBtn = loader.querySelector("button.load");
                    if (loadBtn) {
                        loadBtn.remove();
                    }
                }
                if (callback) {
                    callback();
                }
            });
    }
});
